import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=40515b54"
import script from "./SalesPage.vue?vue&type=script&lang=js"
export * from "./SalesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports